<div class="admin-section-header" [class.collapsed]="designCollapsedInternal">
  <div
    [class.collapsed]="designCollapsedInternal"
    class="d-flex"
    (click)="designCollapsedInternal = !designCollapsedInternal"
  >
    <div>
      Ontwerp
    </div>
    <div class="admin-section-arrow">
      <div>
        <button mat-icon-button>
          <mat-icon class="admin-section-arrow-icon">arrow_drop_up</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div [collapse]="designCollapsedInternal" [isAnimated]="!safari">
  <div class="collapse-content-container">
    <mat-card
      class="design-content__card  top-card summary-card mat-elevation-z0 black-border-color"
    >
      <ip-board-extra-design
        [project]="project"
        [baseProject]="baseProject"
        [ipBoard]="ipBoard"
        (save)="save.emit()"
      ></ip-board-extra-design>
    </mat-card>
  </div>
</div>
